export function generateRandomId() {
    return Math.random().toString(32).slice(2);
}
